import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function getSessionId() {
  return localStorage.getItem("session_id");
}

export function getAuthHeaders() {
  const sessionId = getSessionId();
  return sessionId ? { "X-Session-ID": sessionId } : {};
}

export default function useAuth() {
  const [user, setUser] = useState(undefined);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (sessionId) {
      localStorage.setItem("session_id", sessionId);
      // убрать session_id из URL без перезагрузки
      params.delete("session_id");
      const newSearch = params.toString();
      window.history.replaceState(
        null,
        "",
        window.location.pathname + (newSearch ? "?" + newSearch : "")
      );
    }

    fetch("/auth/me", {
      credentials: "include",
      headers: getAuthHeaders(),
    })
      .then(res => {
        if (res.status === 401) {
          navigate("/login", { replace: true });
          return null;
        }
        return res.json();
      })
      .then(data => {
        if (data) setUser(data);
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [navigate]);

  return user;
}
